// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, SxProps } from "@outschool/backpack";
import { Input } from "@outschool/ui-legacy-component-library";
import React from "react";

import { CARD_ELEMENT_OPTIONS, VARIANT_DEFAULT_SX, Variants } from ".";

type StripeCardZipProps = React.HTMLProps<HTMLInputElement> & {
  ref?: React.Ref<HTMLInputElement>;
  variant?: Variants;
  sx?: SxProps;
};

export default function StripeCardZip({
  variant = Variants.valid,
  sx = {},
  ref,
  ...props
}: StripeCardZipProps) {
  return (
    <Box sx={[VARIANT_DEFAULT_SX[variant], ...(Array.isArray(sx) ? sx : [sx])]}>
      <Input
        data-test-id="postalCode"
        sx={{
          height: `${CARD_ELEMENT_OPTIONS.style.base.height} !important`,
          lineHeight: `${CARD_ELEMENT_OPTIONS.style.base.lineHeight} !important`,
          border: "none !important",
          padding: "0px !important",
          "::placeholder": {
            color: `${CARD_ELEMENT_OPTIONS.style.base["::placeholder"].color}`,
            opacity: 1
          },
          width: "100%"
        }}
        placeholder="12345"
        ref={ref}
        {...props}
      />
    </Box>
  );
}
